import React, { useState } from 'react';

import Head from 'next/head';

import { LatestArticles, WhatNew } from '../../components/blog/sections';
import GetMarketingPlan from '../../components/blog/sections/GetMarketingPlan';

import Offer from '../../components/newOfferModal';

const Blog = () => {
  const [showModal, setShowModal] = useState(false);

  const hideOfferModal = () => {
    setShowModal(false);
    document.documentElement.style.overflow = 'auto';
  };

  const showOfferModal = () => {
    setShowModal(true);
    document.documentElement.style.overflow = 'hidden';
  };

  return (
    <>
      <Head>
        <title>Learn Expert insights with Prodigi Digital Marketing Blog</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/blog" />
        <meta
          name="description"
          content="Discover expert insights, tips, and strategies on the Prodigi Digital Marketing Blog. Stay updated with the latest trends in SEO, social media, and more."
        />
        <meta property="og:url" content="https://weprodigi.com/blog" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Learn Expert insights with Prodigi Digital Marketing Blog" />
        <meta
          property="og:description"
          content="Discover expert insights, tips, and strategies on the Prodigi Digital Marketing Blog. Stay updated with the latest trends in SEO, social media, and more."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/blog/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
  "@context": "http://schema.org",
  "@type": "ItemList",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://weprodigi.com/blog"
  },
  "name": "Learn Expert insights with Prodigi Digital Marketing Blog",
  "description": "Discover expert insights, tips, and strategies on the Prodigi Digital Marketing Blog. Stay updated with the latest trends in SEO, social media, and more.",
  "publisher": {
    "@type": "Organization",
    "name": "Prodigi Digital Marketing Agency",
    "logo": {
      "@type": "ImageObject",
      "url": "https://weprodigi.com/images/logo.png",
      "width": 600,
      "height": 60
    }
  },
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "url": "https://weprodigi.com/blog/digital-marketing-trends-2024",
      "name": "Digital Marketing Trends for 2024"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "url": "https://weprodigi.com/blog/mastering-video-marketing",
      "name": "Mastering Video Marketing: Strategies for Impactful Content"
    },
    {
      "@type": "ListItem",
      "position": 3,
      "url": "https://weprodigi.com/blog/engaging-video-content",
      "name": "How to Create Engaging Video Content"
    },
    {
      "@type": "ListItem",
      "position": 4,
      "url": "https://weprodigi.com/blog/top-tools-for-digital-marketers",
      "name": "Top 5 Tools Every Digital Marketer Should Use"
    },
    {
      "@type": "ListItem",
      "position": 5,
      "url": "https://weprodigi.com/blog/latest-mobile-marketing-trends-2024",
      "name": "Exploring the Latest Mobile Marketing Trends for 2024"
    },
    {
      "@type": "ListItem",
      "position": 6,
      "url": "https://weprodigi.com/blog/seo-or-ppc",
      "name": "SEO or PPC: Deciding Which Strategy Works Best for Your Business"
    },
    {
      "@type": "ListItem",
      "position": 7,
      "url": "https://weprodigi.com/blog/lead-generation-digital-marketing",
      "name": "What is Lead Generation in Digital Marketing: Tips for 2024"
    },
    {
      "@type": "ListItem",
      "position": 8,
      "url": "https://weprodigi.com/blog/key-advertising-trends-2024",
      "name": "Key Advertising Trends to Watch in 2024"
    }
  ]
}
`,
          }}
        />
      </Head>
      <LatestArticles />
      <WhatNew />
      <GetMarketingPlan showModal={showOfferModal} />

      <Offer show={showModal} hide={hideOfferModal} />
    </>
  );
};

export default Blog;
